import {
  useGetMenuItemIngredientsQuery,
  useLinkIngredientToMenuItemMutation,
  useRemoveMenuItemIngredientMutation,
  useUpdateMenuItemIngredientMutation,
} from "@/redux/services/inventory/recipe.api";
import RecipeIngredientsManager from "./RecipeIngredientsManager";
import { usePermissions } from "@/hooks/usePermissions";

interface MenuItemIngredientsProps {
  menuItemId: string;
  restaurantId: string;
}

const MenuItemIngredients = ({
  menuItemId,
  restaurantId,
}: MenuItemIngredientsProps) => {
  // Recipes are read with inventory.view and written with inventory.manage.
  const { canManage } = usePermissions();
  const { data, isLoading } = useGetMenuItemIngredientsQuery({
    menuItemUuid: menuItemId,
  });
  const [link, { isLoading: isLinking }] =
    useLinkIngredientToMenuItemMutation();
  const [remove] = useRemoveMenuItemIngredientMutation();
  const [update, { isLoading: isUpdating }] =
    useUpdateMenuItemIngredientMutation();

  return (
    <RecipeIngredientsManager
      readOnly={!canManage("inventory")}
      restaurantId={restaurantId}
      linkedIngredients={data?.results ?? []}
      isLoading={isLoading}
      isLinking={isLinking}
      isUpdating={isUpdating}
      onLink={async (payload) => {
        const res = await link({ menuItemUuid: menuItemId, data: payload });
        return "data" in res ? { ok: true } : { ok: false };
      }}
      onRemove={async (mapping) => {
        const res = await remove({
          menuItemUuid: menuItemId,
          mappingUuid: mapping.id,
        });
        return "error" in res ? { ok: false } : { ok: true };
      }}
      onUpdate={async (mapping, args) => {
        const res = await update({
          menuItemUuid: menuItemId,
          mappingUuid: mapping.id,
          data: args,
        });
        return "error" in res ? { ok: false } : { ok: true };
      }}
    />
  );
};

export default MenuItemIngredients;
